var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","line-height":"0"}},[_c('img',{staticClass:"headerImg",attrs:{"src":_vm.imgSrc,"alt":""}}),_c('span',{staticClass:"headerimg-slot"},[_vm._v(_vm._s(_vm.headerImgText))])])}
var staticRenderFns = []

export { render, staticRenderFns }